module.exports = __webpack_public_path__ + "static/media/invisible.f3699ac6.svg";